import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOkapiKy } from '@folio/stripes/core';
import { DASHBOARDS_QUERY_KEY } from './useDashboardsAPI';

export default function useDashboardsMutations() {
  const okapiKy = useOkapiKy();
  const queryClient = useQueryClient();

  const invalidate = () => queryClient.invalidateQueries([DASHBOARDS_QUERY_KEY]);

  const createDashboard = useMutation({
    mutationFn: (dashboardData) => okapiKy.post('dashboards', { json: dashboardData }).json(),
    onSuccess: invalidate,
  });

  const updateDashboard = useMutation({
    mutationFn: ({ id, ...dashboardData }) =>
      okapiKy.put(`dashboards/${id}`, { json: { id, ...dashboardData } }),
    onSuccess: invalidate,
  });

  const deleteDashboard = useMutation({
    mutationFn: (dashboardId) => okapiKy.delete(`dashboards/${dashboardId}`),
    onSuccess: invalidate,
  });

  return {
    createDashboard,
    updateDashboard,
    deleteDashboard,
  };
}
